import { styled } from 'styled-components'

import { DEVICE_SIZE } from 'utils/constants'

export const Container = styled.div`
  margin: 0 auto;
  width: 64rem;

  @media (max-width: ${DEVICE_SIZE.LAPTOP}) {
    width: 90%;
  }
`
